import { useEffect, useState } from "react";

import Link from "next/link";

import { withTrackEvent } from "@newsela/snitch";
import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import CHALLENGES_ROUTES from "@/challenges/constants/routes.constants";
import RewardsTotal from "@/challenges/RewardsTotal";
import {
  SIZE_TYPES,
  VALUE_TYPES,
} from "@/challenges/RewardsTotal/RewardsTotal.style";
import {
  challengesEarnedTokensContentCss,
  challengeEarnedTokenTitleCss,
  challengesLinksContentCss,
  challengesLinkCss,
  challengesTokensAmountEarnedContent,
} from "./ChallengeEarnedTokenContent.style";

const propTypes = {
  isStudent: PropTypes.bool,
  articleData: PropTypes.any,
  type: PropTypes.string,
};

const ChallengeEarnedTokenContent = ({
  isStudent = false,
  articleData,
  type,
}) => {
  const [data, setData] = useState(articleData);

  const AnchorWithTrackEvent = withTrackEvent(Anchor);
  const eventPropertiesMoreArticles = {
    objectType: "User",
    actionName: "Navigate",
    event_type: "click",
    streamProperties: {
      application: "parnassus",
      component_type: "ChallengeEarnedTokenContent",
      content_id: data?.article_id,
      content_type: "Article",
      description: "Redirect to Topic Page",
      // user_agent: navigator.userAgent,
    },
  };

  const eventPropertiesView = {
    objectType: "User",
    actionName: "Navigate",
    event_type: "click",
    streamProperties: {
      application: "parnassus",
      component_type: "ChallengeEarnedTokenContent",
      content_id: data?.article_id,
      content_type: "Article",
      description: isStudent
        ? "Redirect to Rewards Page"
        : "Redirect to Challenge Page",
      // user_agent: navigator.userAgent,
    },
  };

  useEffect(() => {
    setData(articleData);
  }, [articleData]);

  return articleData && !articleData?.error_message ? (
    <div css={challengesTokensAmountEarnedContent(isStudent)}>
      {isStudent && (
        <span css={challengesEarnedTokensContentCss}>
          <h6 css={challengeEarnedTokenTitleCss}>Tokens earned</h6>
          <RewardsTotal
            sizeVersion={SIZE_TYPES.VIEW_PAGE_ACTIVITY_PICKER}
            valueVersion={VALUE_TYPES.SINGLE_VALUE}
            articleData={articleData}
            type={type}
          />
        </span>
      )}
      <span css={challengesLinksContentCss}>
        <Link
          href={CHALLENGES_ROUTES.DETAIL(data?.data?.topic_id).route}
          passHref
          legacyBehavior
        >
          <AnchorWithTrackEvent
            {...eventPropertiesMoreArticles}
            dataProps={{
              "data-qa-selector": `IRC: Redirect to Topic Page from article: ${data?.article_id}`,
            }}
            __cssForcss={{ root: challengesLinkCss }}
          >
            View more articles
          </AnchorWithTrackEvent>
        </Link>
        <Link
          href={
            isStudent
              ? CHALLENGES_ROUTES.REWARDS.route
              : CHALLENGES_ROUTES.LANDING.route
          }
          passHref
          legacyBehavior
        >
          <AnchorWithTrackEvent
            {...eventPropertiesView}
            dataProps={{
              "data-qa-selector": `IRC: ${isStudent ? "Redirect to Rewards Page" : "Redirect to Challenge Page"} from article: ${data?.article_id}`,
            }}
            __cssForcss={{ challengesLinkCss }}
          >
            {isStudent ? "View rewards" : "View challenge"}
          </AnchorWithTrackEvent>
        </Link>
      </span>
    </div>
  ) : null;
};

ChallengeEarnedTokenContent.propTypes = propTypes;
export default ChallengeEarnedTokenContent;
